var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "page-wrap" }, [
    _c("section", { staticClass: "form" }, [
      _c(
        "div",
        { staticClass: "form-item" },
        [
          _c(
            "el-select",
            {
              staticClass: "jn-input-style",
              attrs: { clearable: "", placeholder: "选择集配中心" },
              model: {
                value: _vm.formData.logistic_business_id,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "logistic_business_id", $$v)
                },
                expression: "formData.logistic_business_id",
              },
            },
            _vm._l(_vm.businessList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form-item" },
        [
          _c("span", { staticClass: "label" }, [_vm._v("周期：")]),
          _c(
            "el-select",
            {
              staticClass: "jn-input-style",
              attrs: { clearable: "", placeholder: "选择周期" },
              model: {
                value: _vm.order_cycle,
                callback: function ($$v) {
                  _vm.order_cycle = $$v
                },
                expression: "order_cycle",
              },
            },
            _vm._l(_vm.orderCycleList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.id },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm.order_cycle
        ? _c(
            "div",
            { staticClass: "form-item" },
            [
              _c("el-date-picker", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.order_cycle === "1",
                    expression: "order_cycle === '1'",
                  },
                ],
                attrs: {
                  type: "daterange",
                  "range-separator": "至",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  format: "yyyy-MM-dd",
                  "value-format": "yyyy-MM-dd",
                  align: "right",
                },
                on: { change: (val) => _vm.changeCreateDate(val, "daterange") },
                model: {
                  value: _vm.dateTime,
                  callback: function ($$v) {
                    _vm.dateTime = $$v
                  },
                  expression: "dateTime",
                },
              }),
              _c("el-date-picker", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.order_cycle === "2",
                    expression: "order_cycle === '2'",
                  },
                ],
                attrs: { type: "month", placeholder: "选择月" },
                on: { change: (val) => _vm.changeCreateDate(val, "month") },
                model: {
                  value: _vm.monthTime,
                  callback: function ($$v) {
                    _vm.monthTime = $$v
                  },
                  expression: "monthTime",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "form-item btn-wrap" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.onHandleSearch },
            },
            [_vm._v("查询")]
          ),
          _c("el-button", {
            staticClass: "refresh",
            staticStyle: { "margin-left": "5px" },
            attrs: { type: "primary", icon: "el-icon-refresh" },
            on: { click: _vm.onHandleRefresh },
          }),
        ],
        1
      ),
    ]),
    _c("section", { staticClass: "content" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingData,
              expression: "loadingData",
            },
          ],
          staticClass: "count",
        },
        [
          _c(
            "div",
            { staticClass: "count-wrap" },
            [
              _vm._l(_vm.groupedOrderList.specials, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class: index < 3 ? "count-item" : "count-item1",
                    style: {
                      cursor: "pointer",
                      background: item.color,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onHandleExport(item.type)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "value",
                        style: { color: item.font_color },
                      },
                      [
                        _c("span", { staticClass: "amount" }, [
                          _vm._v(_vm._s(item.amt)),
                        ]),
                        _c("span", { staticClass: "unit" }, [_vm._v("元")]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "label",
                        style: { color: item.font_color },
                      },
                      [_vm._v(" " + _vm._s(item.text) + " ")]
                    ),
                    item.type != 51 && item.type != 52 && item.type != 53
                      ? _c("i", { staticClass: "el-icon-download icon-box" })
                      : _vm._e(),
                  ]
                )
              }),
              _vm._l(_vm.groupedOrderList.rows, function (row, rowIndex) {
                return [
                  _vm._l(row, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.type,
                        staticClass: "count-item1",
                        style: { background: item.color, cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.onHandleExport(item.type)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "value",
                            style: { color: item.font_color },
                          },
                          [
                            _c("span", { staticClass: "amount" }, [
                              _vm._v(_vm._s(item.amt)),
                            ]),
                            _c("span", { staticClass: "unit" }, [_vm._v("元")]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "label",
                            style: { color: item.font_color },
                          },
                          [_vm._v(" " + _vm._s(item.text) + " ")]
                        ),
                        item.type != 51 && item.type != 52 && item.type != 53
                          ? _c("i", {
                              staticClass: "el-icon-download icon-box",
                            })
                          : _vm._e(),
                      ]
                    )
                  }),
                  _vm._l(5 - row.length, function (n) {
                    return _c("div", {
                      key: `placeholder-${rowIndex}-${n}`,
                      staticClass: "count-item1 placeholder",
                    })
                  }),
                ]
              }),
            ],
            2
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }